import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MsalAuthModalDialog" */ './lazyIndex'),
    { name: 'MsalAuthModalDialog' }
);

export const MsalAuthModalDialog: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.MsalAuthModalDialog
);
